var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle } from 'react';
import { useTheme } from '../../themes';
import FocusWrapper from '../FocusWrapper';
import * as S from './styles';
export var Switch = forwardRef(function (props, ref) {
    var _a = props.checked, checked = _a === void 0 ? false : _a, onChange = props.onChange, bgColor = props.bgColor, _b = props.size, size = _b === void 0 ? 'large' : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, idProp = props.id, rest = __rest(props, ["checked", "onChange", "bgColor", "size", "disabled", "id"]);
    var theme = useTheme();
    var handleSwitch = function () {
        if (disabled)
            return;
        if (onChange) {
            onChange(!checked);
        }
    };
    var commonStyles = {
        backgroundColor: checked
            ? bgColor || theme.brand.color.primary.pure
            : theme.neutrals.gray3,
    };
    useImperativeHandle(ref, function () { return ({ value: checked }); }, [checked]);
    var id = idProp || 'switch';
    return (_jsx(FocusWrapper, __assign({ disabled: disabled, onClick: handleSwitch, bRadius: "md" }, { children: _jsxs(S.Container, __assign({ "data-testid": "switch", style: __assign({}, commonStyles), checked: checked, size: size }, rest, { children: [_jsx(S.Circle, {}), _jsx("input", { "data-testid": "switch-input", ref: ref, disabled: disabled, type: "checkbox", id: id })] })) })));
});
